// ContentPolicy.js
import React, { useState, useEffect, useRef } from 'react';
import './Pages/PagesCss/ContentPolicy.css';
import { useNavigate } from 'react-router-dom';

// ─── Icons ────────────────────────────────────────────────────────────────────
const Ic = {
  Shield:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3L4 7V12C4 16.42 7.58 21 12 21C16.42 21 20 16.42 20 12V7L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Check:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M8 12L11 15L16 9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Ban:       (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M5.64 5.64L18.36 18.36" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Copyright: (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M14.5 9.5C13.5 8.5 12.5 8 11.5 8C9.5 8 8 9.79 8 12C8 14.21 9.5 16 11.5 16C12.5 16 13.5 15.5 14.5 14.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Report:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 15L12 3L20 15H4Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M12 9V12M12 15H12.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Lock:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M8 11V8C8 5.79 9.79 4 12 4C14.21 4 16 5.79 16 8V11" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><circle cx="12" cy="16" r="1.5" fill="currentColor"/></svg>,
  Users:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="9" cy="7" r="3" stroke="currentColor" strokeWidth="1.8"/><path d="M3 20C3 17.24 5.69 15 9 15C12.31 15 15 17.24 15 20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 11C17.66 11 19 9.66 19 8C19 6.34 17.66 5 16 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M21 20C21 17.79 19.21 16 17 16" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Mail:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><rect x="2" y="4" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="1.8"/><path d="M2 8L12 14L22 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
  Update:    (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M4 12C4 7.58 7.58 4 12 4C14.67 4 17.04 5.27 18.54 7.25" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M20 12C20 16.42 16.42 20 12 20C9.33 20 6.96 18.73 5.46 16.75" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/><path d="M16 7L18.54 7.25L20 5M8 17L5.46 16.75L4 19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ChevronRight: (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M9 5L16 12L9 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  ArrowUp:   (p) => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 19V5M5 12L12 5L19 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  Info:      (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.8"/><path d="M12 8V8.01M12 11V16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  CheckSm:   (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 12L10 17L19 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  XSm:       (p) => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" {...p}><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>,
  Scale:     (p) => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" {...p}><path d="M12 3V21M12 3L6 8M12 3L18 8" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 13L6 8L9 13C9 14.66 7.66 16 6 16C4.34 16 3 14.66 3 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M15 13L18 8L21 13C21 14.66 19.66 16 18 16C16.34 16 15 14.66 15 13Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round"/><path d="M4 21H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/></svg>,
};

// ─── Allowed / Prohibited quick reference ─────────────────────────────────────
const ALLOWED = [
  'Personal PDF documents you own or have rights to process',
  'Business documents contracts, reports, presentations, invoices',
  'Academic work theses, research papers, study materials',
  'Creative files portfolios, ebooks, design documents',
  'Government and public-domain documents',
  'Archiving and backup of your own files',
  'Batch processing via API for your legitimate business workflows',
];

const PROHIBITED = [
  'Content that infringes third-party copyright or intellectual property',
  'Child sexual abuse material (CSAM) or any content exploiting minors',
  'Malware, ransomware, viruses, or any malicious executable content',
  'Documents used to facilitate fraud, phishing, or identity theft',
  'Content that circumvents DRM or anti-copy protections illegally',
  'Classified, secret, or officially restricted government documents',
  'Content that violates applicable law in your jurisdiction',
  'Spam generation, bulk unsolicited communications material',
];

// ─── Sections ─────────────────────────────────────────────────────────────────
const SECTIONS = [
  {
    id: 'overview',
    icon: Ic.Shield,
    title: '1. Overview',
    color: '#3B82F6',
    isOverview: true,
  },
  {
    id: 'acceptable',
    icon: Ic.Check,
    title: '2. Acceptable Content',
    color: '#10B981',
    content: [
      {
        subtitle: 'What you may upload and process',
        body: `QuickPDFs is a general-purpose PDF processing utility. You may use it to process any file that you own or have the legal right to process, provided it does not fall under the prohibited content categories in Section 3.

Examples of clearly acceptable use:

• Personal documents: tax returns, contracts, forms, statements
• Business documents: reports, proposals, invoices, presentations
• Academic work: research papers, theses, study guides, lecture notes
• Creative work: portfolios, ebooks, brochures, design files
• Legal documents you have a right to access and process
• Government and public-domain documents
• Any PDF you created yourself`,
      },
      {
        subtitle: 'Commercial and API use',
        body: `Business plan subscribers may process files on behalf of their clients or customers, provided all uploaded content complies with this Policy. If you are building a product powered by the QuickPDFs API, you are responsible for ensuring your end users also comply with this Policy.

You must not use the API to build a competing PDF processing service, nor to resell access to QuickPDFs functionality without our prior written consent.`,
      },
      {
        subtitle: 'Third-party documents',
        body: `You may process documents owned by third parties if you have their explicit permission to do so, or if the document is in the public domain, or if your processing constitutes fair use under applicable law.

Processing a document does not grant you any new rights over its contents. If you are unsure whether you have the right to process a particular document, consult a legal professional before uploading it.`,
      },
    ],
  },
  {
    id: 'prohibited',
    icon: Ic.Ban,
    title: '3. Prohibited Content',
    color: '#EF4444',
    content: [
      {
        subtitle: 'Absolutely prohibited zero tolerance',
        body: `The following content is strictly prohibited on QuickPDFs and will result in immediate account termination and, where applicable, reporting to law enforcement:

Child sexual abuse material (CSAM): Any content that sexually exploits, depicts, or endangers minors. We report all such content to the National Center for Missing & Exploited Children (NCMEC) and relevant law enforcement authorities without exception.

Malicious files: Files containing malware, ransomware, viruses, trojans, spyware, or any other harmful code intended to damage systems or steal data.

Terrorist or extremist material: Content that promotes, glorifies, or facilitates terrorism, mass violence, or violent extremism.`,
      },
      {
        subtitle: 'Illegal content',
        body: `You may not upload, process, or distribute files that contain or facilitate illegal activity, including:

• Fraud documents fake invoices, fabricated contracts, counterfeit credentials
• Phishing content materials designed to deceive individuals into providing sensitive information
• Identity theft materials fake IDs, forged documents, stolen personal information
• Content that violates export control laws or sanctions
• Classified or officially restricted government documents you are not authorised to access
• Content that violates applicable privacy or data protection laws`,
      },
      {
        subtitle: 'Intellectual property violations',
        body: `You may not use QuickPDFs to:

• Process copyrighted materials without authorisation from the rights holder, where such processing would constitute infringement
• Circumvent digital rights management (DRM) protections this may be illegal under laws such as the DMCA (USA) or the EU Copyright Directive
• Strip or alter copyright notices, watermarks, or attribution from documents
• Extract and redistribute copyrighted content at scale

Processing a legitimately obtained copy of a document for personal format conversion (e.g. PDF to Word for your own use) is generally considered fair use in many jurisdictions. Mass reproduction or distribution is not.`,
      },
      {
        subtitle: 'Abuse of the service',
        body: `The following uses of QuickPDFs are prohibited regardless of file content:

• Creating multiple free accounts to circumvent daily file limits
• Automated scraping or crawling of the website without using the official API
• Deliberate actions intended to overload, damage, or disrupt the service
• Using the service to generate spam documents at scale
• Attempting to probe, scan, or test the security of our infrastructure
• Uploading files solely to test the service's limits with no legitimate processing intent`,
      },
    ],
  },
  {
    id: 'copyright',
    icon: Ic.Copyright,
    title: '4. Copyright & DMCA',
    color: '#8B5CF6',
    content: [
      {
        subtitle: 'Our approach to copyright',
        body: `D-Tech Studios respects intellectual property rights and expects users to do the same. We comply with the Digital Millennium Copyright Act (DMCA) in the United States and equivalent copyright laws in other jurisdictions.

We process files automatically we do not pre-screen uploads for copyright infringement. However, we take action promptly when infringement is reported to us.`,
      },
      {
        subtitle: 'Filing a DMCA takedown notice',
        body: `If you believe content processed through QuickPDFs infringes your copyright, please send a DMCA takedown notice to our designated agent:

Email: legal@quickpdfs.net
Subject: "DMCA Takedown Request"

Your notice must include:
• Your physical or electronic signature
• Identification of the copyrighted work claimed to be infringed
• Identification of the allegedly infringing material
• Your contact information (address, phone, email)
• A statement of good faith belief that the use is not authorised
• A statement that the information is accurate and, under penalty of perjury, that you are the rights holder or authorised to act on their behalf

We will process valid notices within 5 business days.`,
      },
      {
        subtitle: 'Counter-notice',
        body: `If your content was removed in response to a DMCA notice and you believe the removal was in error, you may submit a counter-notice to legal@quickpdfs.net. Your counter-notice must include:

• Your physical or electronic signature
• Identification of the removed material and its location before removal
• A statement under penalty of perjury that the removal was a mistake or misidentification
• Your contact information and consent to jurisdiction

We will forward your counter-notice to the original complainant. If they do not file a court action within 14 business days, we may restore the removed material at our discretion.`,
      },
      {
        subtitle: 'Repeat infringers',
        body: `We maintain a repeat infringer policy. Users who repeatedly infringe third-party intellectual property rights will have their accounts terminated. "Repeatedly" typically means two or more substantiated DMCA notices against a single account within a 12-month period.`,
      },
    ],
  },
  {
    id: 'enforcement',
    icon: Ic.Scale,
    title: '5. Enforcement',
    color: '#F59E0B',
    content: [
      {
        subtitle: 'How we enforce this Policy',
        body: `D-Tech Studios does not routinely scan or review the contents of uploaded files. Our enforcement is primarily reactive we act in response to reports from users, rights holders, law enforcement, and automated detection where technically feasible.

When we become aware of a potential Policy violation, we may take one or more of the following actions depending on severity:

• Issue a warning to the account holder
• Temporarily suspend the account pending investigation
• Permanently terminate the account
• Remove or refuse to process specific files
• Report the content to law enforcement or NCMEC (for CSAM, without exception)
• Preserve relevant records and cooperate with lawful investigations`,
      },
      {
        subtitle: 'Appeals',
        body: `If you believe your account was suspended or terminated in error, you may appeal by emailing legal@quickpdfs.net with the subject line "Content Policy Appeal" within 30 days of the action.

Please include: your account email, a description of the content in question, and your explanation of why you believe the action was in error.

We will review appeals within 10 business days and notify you of our decision. Our decision on appeals is final.`,
      },
      {
        subtitle: 'No liability for user content',
        body: `D-Tech Studios is not responsible for the content users upload. You are solely responsible for ensuring your files comply with this Policy, applicable laws, and third-party rights. We provide tools the responsibility for what you process rests entirely with you.`,
      },
    ],
  },
  {
    id: 'reporting',
    icon: Ic.Report,
    title: '6. Reporting Violations',
    color: '#EF4444',
    content: [
      {
        subtitle: 'How to report a violation',
        body: `If you encounter content processed through QuickPDFs that you believe violates this Policy, please report it to us:

General violations: abuse@quickpdfs.net
Copyright / DMCA: legal@quickpdfs.net
CSAM (immediate): ncmec.org/report or contact local law enforcement immediately, then notify us at abuse@quickpdfs.net

When reporting, please include:
• A description of the suspected violation
• Any relevant details about the content or account
• Your contact information so we can follow up

We review all reports promptly. We will not share your identity with the reported user unless required to do so by law.`,
      },
      {
        subtitle: 'Good-faith reporting',
        body: `We appreciate good-faith reports from the community. Filing false or malicious reports for example, to harass other users or remove legitimate content is itself a violation of this Policy and our Terms of Service, and may result in your own account being suspended.`,
      },
    ],
  },
  {
    id: 'minors',
    icon: Ic.Users,
    title: '7. Protection of Minors',
    color: '#10B981',
    content: [
      {
        subtitle: 'Zero tolerance for CSAM',
        body: `QuickPDFs has a zero-tolerance policy for child sexual abuse material (CSAM) and any content that sexualises, exploits, or endangers children.

We will report all confirmed or suspected CSAM to the National Center for Missing & Exploited Children (NCMEC) CyberTipline and cooperate fully with law enforcement. Accounts involved in uploading such material will be permanently terminated and all relevant data preserved for law enforcement.

If you encounter suspected CSAM anywhere online, report it to:
• NCMEC CyberTipline: www.missingkids.org/gethelpnow/cybertipline
• Your local law enforcement`,
      },
      {
        subtitle: 'Age-appropriate access',
        body: `QuickPDFs is not directed at children under 13. Users under 13 may not use the service. Users aged 13–17 may use the Free plan with parental consent. Paid subscriptions require users to be 18 or older.

If we become aware that a child under 13 has provided personal information through account registration, we will delete that information immediately. If you are a parent or guardian and believe your child has registered, contact privacy@quickpdfs.net.`,
      },
    ],
  },
  {
    id: 'changes',
    icon: Ic.Update,
    title: '8. Changes to This Policy',
    color: '#64748B',
    content: [
      {
        subtitle: 'How we update this Policy',
        body: `D-Tech Studios may update this Content Policy from time to time to reflect changes in our service, applicable law, or community standards. When we make material changes, we will update the "Last updated" date at the top of this page and notify registered account holders by email at least 14 days before the changes take effect.

For minor clarifications that do not substantially change the intent of any provision, we may update the page without prior notice.

Continued use of QuickPDFs after changes take effect constitutes acceptance of the revised Policy.`,
      },
    ],
  },
  {
    id: 'contact',
    icon: Ic.Mail,
    title: '9. Contact',
    color: '#3B82F6',
    content: [
      {
        subtitle: 'Reach us about content matters',
        body: `For all content-related enquiries, reports, and legal matters:

Abuse & violations: abuse@quickpdfs.net
Copyright & DMCA: legal@quickpdfs.net
Privacy matters: privacy@quickpdfs.net
General support: support@quickpdfs.net

Company: D-Tech Studios
Product: QuickPDFs.net

We aim to respond to all content-related reports within 2 business days, and legal notices within 5 business days.`,
      },
    ],
  },
];

// ─── Component ────────────────────────────────────────────────────────────────
export default function ContentPolicy() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState('overview');
  const [showBackToTop, setShowBackToTop] = useState(false);
  const sectionRefs = useRef({});

  useEffect(() => {
    const handler = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) setActiveSection(entry.target.id);
        });
      },
      { rootMargin: '-20% 0px -70% 0px' }
    );
    Object.values(sectionRefs.current).forEach(ref => { if (ref) observer.observe(ref); });
    return () => observer.disconnect();
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const LAST_UPDATED = 'March 18, 2026';

  return (
    <div className="cp2-page">

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="cp2-hero">
        <div className="cp2-hero-bg" aria-hidden="true" />
        <div className="cp2-container">

          <div className="cp2-hero-badge">
            <span className="cp2-badge-dot" />
            D-Tech Studios · QuickPDFs.net
          </div>

          <h1 className="cp2-hero-title">Content Policy</h1>
          <p className="cp2-hero-sub">
            QuickPDFs is a tool for processing legitimate documents. This Policy defines
            what you may and may not upload, and how we handle violations.
          </p>

          <div className="cp2-hero-meta">
            <span className="cp2-meta-item">
              <Ic.Update /> Last updated: <strong>{LAST_UPDATED}</strong>
            </span>
            <span className="cp2-meta-sep">·</span>
            <span className="cp2-meta-item">
              Operated by <strong>D-Tech Studios</strong>
            </span>
          </div>

          {/* Principle cards */}
          <div className="cp2-principles">
            {[
              { icon: Ic.Check,    color: '#10B981', bg: '#ECFDF5', label: 'Permitted',    text: 'Documents you own, public-domain files, legitimate business use' },
              { icon: Ic.Ban,      color: '#EF4444', bg: '#FEF2F2', label: 'Prohibited',   text: 'Illegal content, CSAM, malware, copyright infringement, fraud' },
              { icon: Ic.Scale,    color: '#8B5CF6', bg: '#F5F3FF', label: 'Enforced',     text: 'Warnings, suspension, termination, law enforcement referral' },
              { icon: Ic.Report,   color: '#F59E0B', bg: '#FFFBEB', label: 'Report abuse', text: 'Email abuse@quickpdfs.net reviewed within 2 business days' },
            ].map((p, i) => (
              <div key={i} className="cp2-principle" style={{ '--pc': p.color, '--pbg': p.bg }}>
                <div className="cp2-principle-icon" style={{ background: p.bg, color: p.color }}>
                  <p.icon />
                </div>
                <div>
                  <p className="cp2-principle-label" style={{ color: p.color }}>{p.label}</p>
                  <p className="cp2-principle-text">{p.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Body ──────────────────────────────────────────── */}
      <div className="cp2-body">
        <div className="cp2-container cp2-body-inner">

          {/* TOC */}
          <aside className="cp2-toc">
            <p className="cp2-toc-label">Contents</p>
            <nav className="cp2-toc-nav">
              {SECTIONS.map(s => (
                <button
                  key={s.id}
                  className={`cp2-toc-item${activeSection === s.id ? ' active' : ''}`}
                  style={{ '--tc': s.color }}
                  onClick={() => scrollTo(s.id)}
                >
                  <span className="cp2-toc-dot" style={{ background: s.color }} />
                  <span className="cp2-toc-text">{s.title}</span>
                  <Ic.ChevronRight className="cp2-toc-arrow" />
                </button>
              ))}
            </nav>
            <div className="cp2-toc-footer">
              <button className="cp2-toc-btn" onClick={() => navigate('/TermsOfService')}>
                <Ic.Scale /> Terms of Service
              </button>
              <button className="cp2-toc-btn" onClick={() => navigate('/PrivacyPolicy')}>
                <Ic.Lock /> Privacy Policy
              </button>
              <button className="cp2-toc-btn" onClick={() => navigate('/Contact')}>
                <Ic.Mail /> Contact us
              </button>
            </div>
          </aside>

          {/* Content */}
          <main className="cp2-content">
            {SECTIONS.map(section => (
              <section
                key={section.id}
                id={section.id}
                ref={el => (sectionRefs.current[section.id] = el)}
                className="cp2-section"
              >
                <div className="cp2-section-head">
                  <span className="cp2-section-icon" style={{ background: `${section.color}14`, color: section.color }}>
                    <section.icon />
                  </span>
                  <h2 className="cp2-section-title">{section.title}</h2>
                </div>

                {/* Overview section — allowed / prohibited two-col */}
                {section.isOverview && (
                  <div className="cp2-overview-grid">
                    <div className="cp2-overview-col cp2-overview-col--green">
                      <div className="cp2-overview-col-head">
                        <Ic.CheckSm />
                        Allowed
                      </div>
                      {ALLOWED.map((item, i) => (
                        <div key={i} className="cp2-overview-item">
                          <span className="cp2-overview-dot cp2-overview-dot--green" />
                          {item}
                        </div>
                      ))}
                    </div>
                    <div className="cp2-overview-col cp2-overview-col--red">
                      <div className="cp2-overview-col-head">
                        <Ic.XSm />
                        Not allowed
                      </div>
                      {PROHIBITED.map((item, i) => (
                        <div key={i} className="cp2-overview-item">
                          <span className="cp2-overview-dot cp2-overview-dot--red" />
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Standard prose */}
                {!section.isOverview && section.content?.map((block, i) => (
                  <div key={i} className="cp2-block">
                    <h3 className="cp2-block-title" style={{ '--bc': section.color }}>{block.subtitle}</h3>
                    <div className="cp2-block-body">
                      {block.body.split('\n\n').map((para, j) => (
                        <p
                          key={j}
                          className={
                            para.trim().startsWith('•') || para.includes('\n•')
                              ? 'cp2-para cp2-para--list'
                              : 'cp2-para'
                          }
                        >
                          {para.split('\n').map((line, k, arr) => (
                            <span key={k}>
                              {line}
                              {k < arr.length - 1 && <br />}
                            </span>
                          ))}
                        </p>
                      ))}
                    </div>
                  </div>
                ))}
              </section>
            ))}

            {/* Footer */}
            <div className="cp2-footer-note">
              <Ic.Info className="cp2-footer-icon" />
              <div>
                <p className="cp2-footer-title">This Policy works with our other legal documents</p>
                <p className="cp2-footer-body">
                  Read our{' '}
                  <button className="cp2-inline-link" onClick={() => navigate('/TermsOfService')}>Terms of Service</button>
                  {' '}and{' '}
                  <button className="cp2-inline-link" onClick={() => navigate('/PrivacyPolicy')}>Privacy Policy</button>
                  {' '}for the complete picture. To report a violation contact{' '}
                  <a className="cp2-inline-link" href="mailto:abuse@quickpdfs.net">abuse@quickpdfs.net</a>.
                </p>
              </div>
            </div>
          </main>
        </div>
      </div>

      {/* Back to top */}
      {showBackToTop && (
        <button
          className="cp2-back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="Back to top"
        >
          <Ic.ArrowUp />
        </button>
      )}
    </div>
  );
}